import {client} from '../helpers/api';

export async function postUserDeleteAccount() {
  const response = await client.delete('/api/delete-account');

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    return response.data?.message || '';
  }
  throw response;
}
